import { render, staticRenderFns } from "./BasisAdd.vue?vue&type=template&id=5a516276&scoped=true"
import script from "./BasisAdd.vue?vue&type=script&lang=js"
export * from "./BasisAdd.vue?vue&type=script&lang=js"
import style0 from "./BasisAdd.vue?vue&type=style&index=0&id=5a516276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a516276",
  null
  
)

export default component.exports